import { jsx as _jsx } from "react/jsx-runtime";
import { AccountEnrichment } from '../../components/account/account-enrichment/AccountEnrichment';
const AccountEnrichmentContainer = props => {
    return _jsx(AccountEnrichment, Object.assign({}, props));
};
export default AccountEnrichmentContainer;
